import React from "react";

const DownloadIconSmall = () => {
  return (
    <svg
      id="downld_ic"
      xmlns="http://www.w3.org/2000/svg"
      width="16.37"
      height="16.339"
      viewBox="0 0 16.37 16.339"
    >
      <path
        id="Path_1254"
        data-name="Path 1254"
        d="M57.57,257.878V261.5a.825.825,0,0,1-.026.2h0a.778.778,0,0,1-.758.624H41.978a.776.776,0,0,1-.768-.691.61.61,0,0,1-.01-.139v-3.624a.773.773,0,0,1,1.546,0v2.9H56.029v-2.9a.773.773,0,0,1,1.32-.546A.817.817,0,0,1,57.57,257.878Z"
        transform="translate(-41.2 -245.987)"
      />
      <path
        id="Path_1255"
        data-name="Path 1255"
        d="M117.675,49.762l-3.8,3.8c-.005.01-.015.015-.021.021a.9.9,0,0,1-.5.253c-.015,0-.031.005-.046.005a.561.561,0,0,1-.093.005h0l-.088-.005c-.015,0-.031-.005-.046-.005a.879.879,0,0,1-.5-.253l-.021-.021-3.8-3.8a.9.9,0,1,1,1.278-1.278l2.283,2.283V42.4a.906.906,0,0,1,.9-.9.922.922,0,0,1,.639.263.891.891,0,0,1,.263.639v8.366l2.283-2.283a.908.908,0,0,1,1.278,0A.923.923,0,0,1,117.675,49.762Z"
        transform="translate(-105.031 -41.5)"
      />
    </svg>
  );
};

export default DownloadIconSmall;
